"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USES = exports.WEIGHTS = void 0;
var WEIGHTS = {
  regular: 'regular',
  medium: 'medium',
  bold: 'bold',
  demi: 'demi'
};
exports.WEIGHTS = WEIGHTS;
var USES = {
  error: 'error',
  help: 'help',
  success: 'success'
};
exports.USES = USES;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/elements/TextElementConstants.js
// module id = 616
// module chunks = 5 6